export default __webpack_public_path__ + "static/media/website.27f08f46.png";